/**
 * API Configuration - Environment-dependent URLs
 */

// Get the base URL for Firebase Functions based on environment.
//
// The project is taken from REACT_APP_FIREBASE_PROJECT_ID rather than
// hardcoded: it was previously pinned to the production project, so a
// staging build called production's Cloud Functions.
export const getFunctionsBaseUrl = (): string => {
  const isLocalhost = window.location.hostname === 'localhost' ||
                     window.location.hostname === '127.0.0.1';
  const isDev = process.env.NODE_ENV === 'development' && isLocalhost;

  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  if (!projectId) {
    throw new Error(
      'REACT_APP_FIREBASE_PROJECT_ID is not set — refusing to guess which ' +
      'project to call Cloud Functions on.'
    );
  }

  if (isDev) {
    // Local emulator
    return `http://localhost:5001/${projectId}/us-central1`;
  } else {
    return `https://us-central1-${projectId}.cloudfunctions.net`;
  }
};

// Helper to build function URL
export const buildFunctionUrl = (functionName: string): string => {
  return `${getFunctionsBaseUrl()}/${functionName}`;
};